export interface LinkData {
  title: string
  link: string
  rel?: 'noreferrer'
  target?: '_top'
  type?: 'mail'
  nativeAnchor?: boolean
}

interface OneDataItem {
  heading: string
  listItems: Array<LinkData>
}

type Data = OneDataItem[]

export const mainNavData: Data = [
  {
    heading: 'INDSTOCKS',
    listItems: [
      {
        title: 'About Us',
        link: '/page/about/indstocks',
      },
      {
        title: 'Privacy Policy',
        link: '/privacy-policy',
      },
      {
        title: 'Terms of Service',
        link: '/page/terms-conditions-indian-stocks',
      },
      {
        title: 'Grievance Redressal Policy',
        link: '/grievance-redressal-policy?type=indian-stocks',
      },
    ],
  },
  {
    heading: 'QUICK LINKS',
    listItems: [
      {
        title: 'Customer Service',
        link: '/customer-service',
      },
      {
        title: 'Escalation Matrix',
        link: '/page/escalation-matrix?type=indian-stocks',
      },
      {
        title: 'Legal and Regulatory',
        link: '/page/policy-center?type=indstocks',
      },
      {
        title: 'Disclaimers',
        link: '/page/disclaimers',
      },
      { title: 'Fraud Awareness', link: '/page/fraud-awareness' },
    ],
  },
]

/************ QUICK LINKS ***********/

export const indianStocksQuickLinks = [
  {
    title: 'Tata Motors Share Price',
    link: '/stocks/tata-motors-ltd-share-price',
  },
  {
    title: 'Eternal Share Price',
    link: '/stocks/eternal-ltd-share-price',
  },
  {
    title: 'ITC Share Price',
    link: '/stocks/itc-ltd-share-price',
  },
  {
    title: 'Yes Bank Share Price',
    link: '/stocks/yes-bank-ltd-share-price',
  },
  {
    title: 'Tata Steel Share Price',
    link: '/stocks/tata-steel-ltd-share-price',
  },
]
